import { render, staticRenderFns } from "./MovementUpdate.vue?vue&type=template&id=af4582ee&scoped=true&"
import script from "./MovementUpdate.vue?vue&type=script&lang=js&"
export * from "./MovementUpdate.vue?vue&type=script&lang=js&"
import style0 from "./MovementUpdate.vue?vue&type=style&index=0&id=af4582ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4582ee",
  null
  
)

export default component.exports